/* AUTO-GENERATED by scripts/gen_chat_action_types.py. */

export type TargetLabel = string | null;
export type RenderAs = "action_card";
export type Action = ByomModelDestination | DashboardDestination;
export type Destination = "byom_model";
export type ConfigId = string;
export type Destination1 = "dashboard";

export interface ActionCardMetadata {
  target_label?: TargetLabel;
  render_as: RenderAs;
  action: Action;
}
export interface ByomModelDestination {
  destination: Destination;
  config_id: ConfigId;
}
export interface DashboardDestination {
  destination: Destination1;
}

import Ajv from 'ajv'
const schema = {"definitions": {"ByomModelDestination": {"additionalProperties": false, "properties": {"destination": {"const": "byom_model", "title": "Destination", "type": "string"}, "config_id": {"pattern": "^[A-Za-z0-9_-]{1,128}$", "title": "Config Id", "type": "string"}}, "required": ["destination", "config_id"], "title": "ByomModelDestination", "type": "object"}, "DashboardDestination": {"additionalProperties": false, "properties": {"destination": {"const": "dashboard", "title": "Destination", "type": "string"}}, "required": ["destination"], "title": "DashboardDestination", "type": "object"}}, "additionalProperties": false, "properties": {"target_label": {"anyOf": [{"type": "string"}, {"type": "null"}], "default": null, "title": "Target Label"}, "render_as": {"const": "action_card", "title": "Render As", "type": "string"}, "action": {"discriminator": {"mapping": {"byom_model": "#/definitions/ByomModelDestination", "dashboard": "#/definitions/DashboardDestination"}, "propertyName": "destination"}, "oneOf": [{"$ref": "#/definitions/ByomModelDestination"}, {"$ref": "#/definitions/DashboardDestination"}], "title": "Action"}}, "required": ["render_as", "action"], "title": "ActionCardMetadata", "type": "object"}

const validateActionCard = new Ajv({ allErrors: true }).compile(schema)

function isActionCardMetadata(value: object): value is ActionCardMetadata {
  return validateActionCard(value) === true
}

export function parseActionCardMetadata(value: object): ActionCardMetadata {
  if (!isActionCardMetadata(value)) {
    throw new Error(`Invalid Director action card: ${JSON.stringify(validateActionCard.errors)}`)
  }
  return value
}
